import React from 'react';
import { isIterable } from '../../utils/helpers/utils';
import { useDarkMode } from '../../utils/hooks/useDarkMode';
import { DesktopFooter, MobileFooter } from './footer';

/**
 * Footer Section Component
 * Main footer component that renders desktop and mobile versions
 * 
 * @param {Object} props
 * @param {Object} props.data - The footer data
 * @param {String} props.data.FooterDescription - Company description
 * @param {String} props.data.Copyrights - Copyright text
 * @param {Object} props.data.footerIcon - Company logo
 * @param {Array} props.data.rightBottomLinks - Legal links
 * @param {Array} props.data.LeftBottomLinks - Service links
 * @param {Array} props.data.socialIcons - Social media links
 * @param {Array} props.data.Address - Contact addresses
 * @param {String} props.className - Optional additional CSS class
 */
const FooterSection = ({ data, className = '' }) => {
    const { isDarkMode } = useDarkMode();

    if (!data) return null;

    // Ensure Address is an array
    if (!isIterable(data.Address)) {
        data.Address = [data.Address];
    }

    return (
        <>
            <DesktopFooter 
                data={data} 
                isDarkMode={isDarkMode} 
                className={className} 
            />
            <MobileFooter 
                data={data} 
                isDarkMode={isDarkMode} 
                className={className} 
            />
        </>
    );
};

export default FooterSection;
